import { MaskitoOptions } from "@maskito/core";
import {
	maskitoAddOnFocusPlugin,
	maskitoCaretGuard,
	maskitoDateOptionsGenerator,
	maskitoNumberOptionsGenerator,
	maskitoPrefixPostprocessorGenerator,
	maskitoRemoveOnBlurPlugin,
} from "@maskito/kit";
import { CustomMaskitoMask } from "./custom-maskito-mask";

export class MaskitoMasks {
	private static amountMaskOptions: Required<MaskitoOptions> = maskitoNumberOptionsGenerator({
		decimalSeparator: ",",
		thousandSeparator: "",
		precision: 2,
	});

	private static emptyMask: string[] = [];

	private static dateMaskOptions: Required<MaskitoOptions> = maskitoDateOptionsGenerator({
		mode: "dd/mm/yyyy",
		separator: "/",
	});

	private static ibanMask: string[] = [
		...Array(2).fill(/\w/),
		...Array(2).fill(/\w/),
		" ",
		...Array(4).fill(/\w/),
		" ",
		...Array(4).fill(/\w/),
		" ",
		...Array(4).fill(/\w/),
		" ",
		...Array(4).fill(/\w/),
		" ",
		...Array(4).fill(/\w/),
		" ",
		...Array(3).fill(/\w/),
	];

	private static phoneNumberMask: string[] = [
		...Array(2).fill(/\d/),
		" ",
		...Array(2).fill(/\d/),
		" ",
		...Array(2).fill(/\d/),
		" ",
		...Array(2).fill(/\d/),
		" ",
		...Array(2).fill(/\d/),
	];

	private static phoneNumberMaskOptions: MaskitoOptions = {
		mask: this.phoneNumberMask,
		postprocessors: [
			// non-removable prefix
			maskitoPrefixPostprocessorGenerator("0"),
		],
		plugins: [
			maskitoAddOnFocusPlugin("0"),
			maskitoRemoveOnBlurPlugin("0"),
			maskitoCaretGuard((value, [from, to]) => [from === to ? "0".length : 0, value.length]),
		],
	} as MaskitoOptions;

	private static pinCodeMask = new RegExp("^\\d{0,6}$");

	static amount = new CustomMaskitoMask(MaskitoMasks.emptyMask, MaskitoMasks.amountMaskOptions);
	static date = new CustomMaskitoMask(MaskitoMasks.emptyMask, MaskitoMasks.dateMaskOptions);
	static iban = new CustomMaskitoMask(MaskitoMasks.ibanMask);
	static phoneNumber = new CustomMaskitoMask(MaskitoMasks.phoneNumberMask, MaskitoMasks.phoneNumberMaskOptions);
	static pinCode = new CustomMaskitoMask(MaskitoMasks.pinCodeMask);
}
